export default __webpack_public_path__ + "static/media/ico-google.27bc8964.svg";